import React, {useState} from 'react'
import { Box, Button, Card, CardBody, Form, FormField, TextInput, CardFooter, CardHeader,Image,Text,Spinner,Layer } from 'grommet'
import { Login, User, Lock, Alert } from 'grommet-icons'
import { withRouter } from 'react-router-dom';
import { Auth } from 'aws-amplify';


const userError = (error, errorMessage) => {
  if (error){
    return <Box margin='small' pad='small' elevation='small' align='center' justify='center' direction='row'><Alert pad='small'color='status-critical' /><Text pad='small'size='small'>{errorMessage.message}</Text></Box>
  } else {
    return null
  }
}


function LoginForm (props) {
  const [loginForm, setLoginForm] = useState({username: '', password: ''})
  const [load, setLoad] = useState(false)
  const [error, setError] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const handleSubmit = (e) => {
    setLoad(true)
    var username = loginForm.username
    var password = loginForm.password
    Auth.signIn(username, password).then(res => {
      sessionStorage.setItem("isUserAuthenticated", true)
      sessionStorage.setItem("token", res.signInUserSession.idToken.jwtToken.toString())
      sessionStorage.setItem("username", res.username.toString())
      sessionStorage.setItem("email", res.attributes.email.toString())
      props.handleIsUserAuthenticated(true)
      setLoad(false)
      setError(false)
      props.setUserRole(res.signInUserSession.idToken.payload["cognito:groups"][0])
      if (res.signInUserSession.idToken.payload["cognito:groups"][0] === 'SuperAdmin'){
        props.history.push({
          pathname: '/admin/dashboard'
        })
      } else {
        props.history.push({
          pathname: '/shipment/new'
        })
      }
    }).catch(err => {
      sessionStorage.setItem("isUserAuthenticated", false)
      setError(true)
      setErrorMessage(err)
      setLoad(false)
      props.handleIsUserAuthenticated(false)
    })
   }
   if (load){
     return (
        <Layer>
          <Box align='center' justify='center' margin="medium">
              <Spinner margin='small' size='medium' />
              <Text margin='small'>Loading Dashboard...</Text>
            </Box>
        </Layer>
      )
   } else {
    return (
      <Box justify='center' direction='column' margin="medium" width='xlarge' align='center' alignSelf='center' style={{paddingTop: 120}}>
        <Card pad="small" elevation='large' width='large'>
          <CardHeader>
          <Image fit="contain"style={{height:125}}src="./labship.png"/>
          </CardHeader>
            <CardBody pad="small">
            {userError(error, errorMessage)}
              <Form value={loginForm} onSubmit={handleSubmit} onChange={nextValue => setLoginForm(nextValue)}>
                <FormField label="Username" required name="username">
                  <TextInput name='username' icon={<User />} placeholder="Username..." style={{width:400}} />
                </FormField>
                <FormField label="Password" required name="password">
                  <TextInput name='password' icon={<Lock />} placeholder="Password..." type='password' style={{width:400}}/>
                </FormField>
                <CardFooter align="center" direction="row" flex={false} justify="between" gap="medium" pad="small">
                    <Button primary hoverIndicator label="Login" icon={<Login />} type='submit' />
                    <Button primary hoverIndicator label="Request Account" icon={<User />} onClick={() => {window.open('mailto:labship@samplelogistics.com?subject=Sample Logistics LabShip - Account Request')}} />
                </CardFooter>
                </Form>
              </CardBody>
            </Card>
      </Box>
    )
   }
}

export default withRouter(LoginForm)
